import { Authentication } from '@/app/features/Authentication';
import { ResendActivation } from '@/app/features/Authentication/ResendActivation';
import { AuthorizationError } from '@/app/features/AuthorizationError';
import { AccessDenied } from '@/app/features/AccessDenied';
import ApplicationWrapper from '@/app/features/common/Layout/ApplicationWrapper';
import PublicLayout from '@/app/features/common/PublicLayout';
import { InvoiceBillingReminder } from '@/app/features/InvoiceBillingReminder';
import { getCompanyData } from '@/app/shared/constants/companies';
import { TriumphPartnerId } from '@/app/shared/constants/companies/triumph';
import { useFeatureFlags } from '@/app/shared/utils/hooks/useFeatureFlags';
import { LoginCallback } from '@/app/features/Authentication/LoginCallback';
import { useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import AuthenticatedRoutes from './AuthenticatedRoutes';
import { PageRoutes } from './routes';

const companyData = getCompanyData();

const PageRouterWrapper = () => {
  const { DebtorPortalAuthentication } = useFeatureFlags();

  const isDebtorPortal = useMemo(() => {
    return (
      DebtorPortalAuthentication &&
      companyData.partnerId === TriumphPartnerId &&
      window.location.hostname.includes('invoices.')
    );
  }, [DebtorPortalAuthentication]);

  return (
    <Routes>
      {isDebtorPortal ? (
        <Route path={PageRoutes.LOGIN} element={<PublicLayout />}>
          <Route index element={<Authentication />} />
        </Route>
      ) : null}
      <Route path={PageRoutes.RESEND_ACTIVATION} element={<PublicLayout />}>
        <Route index element={<ResendActivation />} />
      </Route>
      <Route element={<ApplicationWrapper />}>
        <Route
          path={PageRoutes.BILLING_REMINDER}
          element={<InvoiceBillingReminder />}
        />
        <Route path={PageRoutes.CALLBACK} element={<LoginCallback />} />
        <Route path={PageRoutes.AUTH_ERROR} element={<AuthorizationError />} />
        <Route path={PageRoutes.ACCESS_DENIED} element={<AccessDenied />} />
        {isDebtorPortal ? (
          <Route path={PageRoutes.HOME} element={<AuthenticatedRoutes />} />
        ) : (
          <Route path={PageRoutes.HOME} element={<InvoiceBillingReminder />} />
        )}
      </Route>
    </Routes>
  );
};

export { PageRouterWrapper as PageRouter };
